package com.mps.asc_app.data.config

import kotlin.time.ExperimentalTime
import kotlin.time.Instant

@OptIn(ExperimentalTime::class)
data class TimeslotConfig(
    val bookingEnabled: Boolean = true,
    val bookingOpenAt : Instant? = null,
    /**
     * Wenn false: normale Mitglieder sehen bei belegten Slots keine Namen mehr (nur "Belegt").
     * Admins und der Buchende selbst sehen weiterhin Details.
     */
    val bookingNamesPublic: Boolean = true,
    val start: String = "10:00",
    val end: String = "22:00",
    val intervalMinutes: Int = 60,
)